import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import GlowCard from './GlowCard';
import { useColors } from '../theme/ColorModeContext';

interface StatCardProps {
  icon: React.ReactNode;
  value: string | number;
  label: string;
  accentColor?: string;
  children?: React.ReactNode;
}

const StatCard = ({ icon, value, label, accentColor, children }: StatCardProps) => {
  const colors = useColors();
  const gradientLine = accentColor
    ? `linear-gradient(90deg, ${accentColor}, transparent)`
    : colors.gradient.primary;

  return (
    <GlowCard accentTop glowOnHover={false} sx={{ padding: 0 }}>
      <Box sx={{ height: '2px', background: gradientLine }} />
      <Box sx={{
        padding: '20px',
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
      }}>
        <Box sx={{
          width: 44,
          height: 44,
          borderRadius: '8px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: colors.gradient.primarySubtle,
          color: accentColor || colors.accent.cyan,
          flexShrink: 0,
        }}>
          {icon}
        </Box>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography
            variant="h5"
            sx={{
              fontFamily: '"Orbitron", sans-serif',
              fontWeight: 700,
              lineHeight: 1.2,
            }}
          >
            {value}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: colors.text.secondary,
              fontSize: '0.8rem',
              marginTop: '2px',
            }}
          >
            {label}
          </Typography>
        </Box>
        {children}
      </Box>
    </GlowCard>
  );
};

export default StatCard;
